//! NOTE: A lot of this JS is "old school" (use of var, no fat-arrow function, no template string) in order to maximise browser compatibility — this can be relaxed moving into 2025
document.addEventListener('DOMContentLoaded', function() {
  function updateScrollbarWidthValue() {
  	const scrollbarWidth = Math.min(20, Math.ceil(window.innerWidth - document.documentElement.clientWidth)) || 0;
  	document.documentElement.style.setProperty('--DOC-SCROLLBAR-WIDTH', `${scrollbarWidth}px`);
  	return scrollbarWidth;
  }
  
  updateScrollbarWidthValue();

  // Run this again on subsequent changes
  const resizeObserver = new ResizeObserver((entries) => {
    if (!entries[0].target.clientHeight) {
        return;
    }
    const newWidth = updateScrollbarWidthValue();
    if (newWidth >= 10) {
        // Based on this (@link https://codepen.io/sambible/post/browser-scrollbar-widths), a scrollbar over 10px should cover most cases
        resizeObserver.disconnect(); // We've got a significant scrollbar width, no need to look for additional changes
    }
  });
  requestAnimationFrame(function () { resizeObserver.observe(document.body); });

  Array.from(document.querySelectorAll('[data-swipe-enabled]')).forEach(function (gestureZone){
    let touchstartX = 0;
    let touchstartY = 0;
    let touchendX = 0;
    let touchendY = 0;
    
    gestureZone.addEventListener('touchstart', function(event) {
        touchstartX = event.changedTouches[0].screenX;
        touchstartY = event.changedTouches[0].screenY;
    }, false);
    
    gestureZone.addEventListener('touchend', function(event) {
        touchendX = event.changedTouches[0].screenX;
        touchendY = event.changedTouches[0].screenY;
        handleGesture();
    }, false); 
    
    function handleGesture() {
      let moveX = touchendX - touchstartX;
      let moveY = touchendY - touchstartY;
      let deltaX = Math.abs(moveX);
      let deltaY = Math.abs(moveY);
      let thresholdX = 50;

      if (deltaX < deltaY) { return; } // Vertical scroll, discard
      if (moveX === 0 && moveY === 0) { return; } // Tap, discard
      if (deltaX < thresholdX) { return; } // Very little scroll, discard

      let event = new CustomEvent('muse:swipe', {
        bubbles: true,
        detail: {
          swipeX: moveX,
          swipeY: moveY,
          swipeDirection: {
            x: moveX > 0 ? 'right' : 'left',
            y: moveY > 0 ? 'down' : 'up',
          }
        }
      });
      gestureZone.dispatchEvent(event);

      // if (moveX < 0) {
      //     console.log('Swiped left');
      // }
      
      // if (moveX > 0) {
      //     console.log('Swiped right');
      // }
      
      // if (touchendY < touchstartY) {
      //     console.log('Swiped up');
      // }
      
      // if (touchendY > touchstartY) {
      //    console.log('Swiped down');
      // }
    }
  });

  Array.from(document.querySelectorAll('a[href][data-audio-player]')).forEach(function (a) {
    var button = document.createElement('button');
    button.type = 'button';
    var audioSrc = a.href;

    // Copy all attributes...
    (Array.from(a.attributes) || []).forEach(function(attr) {
      // ...except the href and data-attribute marking the node for conversion
      if (['target', 'href', 'data-audio-player'].includes(attr.nodeName) === false) {
        button.setAttribute(attr.nodeName, attr.nodeValue);
      }
    });
    button.setAttribute('aria-pressed', 'false');
    button.setAttribute('data-audio-button', '');

    // Add icons for the button
    button.innerHTML = 
      '<svg xmlns="http://www.w3.org/2000/svg" class="button-icon button-icon--paused" width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><rect x="6" y="4" width="4" height="16"></rect><rect x="14" y="4" width="4" height="16"></rect></svg>'
      +
      '<svg xmlns="http://www.w3.org/2000/svg" class="button-icon button-icon--playing" width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><polygon points="5 3 19 12 5 21 5 3"></polygon></svg>';

    // Move all child nodes from the a into the button
    (Array.from(a.childNodes) || []).forEach(function(child) {
      button.append(child);
    });

    // Place the button right after the original a
    a.insertAdjacentElement('afterend', button);

    // Delete the original a
    a.parentElement.removeChild(a);

    // Create a hidden audio element
    var audio = document.createElement('audio');
    audio.setAttribute('src', audioSrc);
    audio.setAttribute('loop', 'loop');
    audio.setAttribute('crossorigin', 'anonymous');
    audio.setAttribute('class', 'visually-hidden');
    button.appendChild(audio);

    button.addEventListener('click', function() {
      if (audio.paused) {
        // Pause any currently running media
        Array.from(document.querySelectorAll('audio, video:not([muted])')).forEach(function (media) {
          if (media !== audio) {
            media.pause();
          }
        });
        
        audio.play();
      }
      else { audio.pause(); }
    });
    audio.addEventListener('play', function() {
      button.setAttribute('aria-pressed', 'true');
    });
    audio.addEventListener('pause', function() {
      button.setAttribute('aria-pressed', 'false');
    });
  });

  var pageTemplate = document.querySelector('[data-page-template]') ? document.querySelector('[data-page-template]').getAttribute('data-page-template') : null;
  if (pageTemplate.indexOf('product-v2') > -1) {
    // Rearrange very specific elements to be into a grid
    Array.from(document.querySelectorAll('.v2-media-container + .v2-media-container + .v2-contained-carousel__wrapper')).forEach(function(lastCarousel){
      var sideMedia = lastCarousel.previousElementSibling;
      var mainMedia = sideMedia.previousElementSibling;
      var newWrapper = document.createElement('div');
      var newContainer = document.createElement('div');
      newContainer.className = 'container';
      newWrapper.className = 'v2-pdp-media-carousel-group__wrapper';
      
      lastCarousel.classList.add('v2-pdp-media-carousel-group__block','v2-pdp-media-carousel-group__block--carousel');
      sideMedia.classList.add('v2-pdp-media-carousel-group__block','v2-pdp-media-carousel-group__block--side');
      mainMedia.classList.add('v2-pdp-media-carousel-group__block','v2-pdp-media-carousel-group__block--main');
      
      lastCarousel.parentNode.insertBefore(newContainer, lastCarousel.nextSibling);
      newContainer.appendChild(newWrapper);
      
      newWrapper.appendChild(mainMedia);
      newWrapper.appendChild(sideMedia);
      newWrapper.appendChild(lastCarousel);
    });
  }
  if (pageTemplate.indexOf('page-sleep') > -1) {
    // Rearrange very specific elements to be into a grid
    Array.from(document.querySelectorAll('.v2-media-container + .v2-media-container + .v2-media-container')).forEach(function(lastCarousel){
      var sideMedia = lastCarousel.previousElementSibling;
      var mainMedia = sideMedia.previousElementSibling;
      var newWrapper = document.createElement('div');
      var newContainer = document.createElement('div');
      newContainer.className = 'main-sleep-wrapper';
      newWrapper.className = 'v2-sleep-media-carousel-group__wrapper';
      
      lastCarousel.classList.add('v2-pdp-media-carousel-group__block','v2-pdp-media-carousel-group__block--carousel');
      sideMedia.classList.add('v2-pdp-media-carousel-group__block','v2-pdp-media-carousel-group__block--side');
      mainMedia.classList.add('v2-pdp-media-carousel-group__block','v2-pdp-media-carousel-group__block--main');
      
      lastCarousel.parentNode.insertBefore(newContainer, lastCarousel.nextSibling);
      newContainer.appendChild(newWrapper);
      
      newWrapper.appendChild(mainMedia);
      newWrapper.appendChild(sideMedia);
      newWrapper.appendChild(lastCarousel);
    });
  }
});
document.addEventListener('click', function(e) {
  var video = e.target.closest('[data-video] video');
  if (video) {
    var videoWrap = video.closest('[data-video]')
    if (video.paused) {
      // Pause any currently running media
      Array.from(document.querySelectorAll('audio, video:not([muted])')).forEach(function (media) {
        if (media !== video) {
          media.pause();
        }
      });
      
      video.play();
      videoWrap.setAttribute('data-video', 'playing');
    } else {
      video.pause();
      videoWrap.setAttribute('data-video', 'paused');
    }
  }
});

// Additional details for details animations: a toggle doesn't bubble to the top of the DOM so our custom implementation will
document.addEventListener('muse:details-toggle', function(e) {
    var details = e.detail.target.closest('details.v2-expander-group__item');
    if (!details) {
        return;
    }
  
    // Not unusual for the content to be selected upon expand
    window.getSelection().removeAllRanges();
  
    var oldState = e.detail.oldState;
    var newState = e.detail.newState;
    if (newState === oldState || newState !== 'opened' ) {
        return; // Don't scroll if this is closing or already opened
    }
  
    try {
      // Listen I wish scrollMarginTop would work but it doesn't in Chrome :shrug:
      //details.querySelector('summary').scrollIntoView({ behavior: 'instant', block: 'start' });
      //*
      details.scrollIntoView({ behavior: 'instant', block: 'start' });
      var scrollMarginTop = parseFloat(window.getComputedStyle(details).scrollMarginTop);
      var topOffset = details.getBoundingClientRect().top;
      if (topOffset < scrollMarginTop) {
        window.scrollBy({ behavior: 'instant', top: Math.min(0, scrollMarginTop - topOffset) });
      }
      //*/
    } catch (e) { console.warn('Could not scroll into view.', e); }
});

/** Helper function to set a discount code in the cookie */
function setDiscountCookie(value) {
  let expires = '';
  let daysToExpire = 7;
  let date = new Date();
  date.setTime(date.getTime() + daysToExpire * 24 * 60 * 60 * 1000);
  expires = '; expires=' + date.toUTCString();
  document.cookie = 'discount_code=' + (value || '') + expires + '; path=/';
}